module.exports = __webpack_public_path__ + "static/media/team.5e0c7961.png";